import slice from './slice';

export const {
    loadJobs, loadJobsFailed, addJob, removeJob, reset, setJob, updateLocalJobState,
    updateDisplayedCompoundJobs, setJobState, updateDisplayedScreeningJobs,
} = slice.actions;
export default slice.reducer;
